module.exports = __webpack_public_path__ + "img/47.157f0150.jpg";